module.exports = __webpack_public_path__ + "media/vid_body_feature2.778eaeda.mp4";